import {
  cancelDonation,
  cancelSubscription,
  changeAmountSubscription,
  confirmPayment,
  confirmPaymentSubscription,
  confirmPaymentSubscriptionPayMongo,
  getClientKey,
  getPaymentMethods,
  getPaymentMethodsSubscription,
  makePayment,
  makePaymentDonation,
  makePaymentSubscription,
  makePaymentSubscriptionPayMongo,
  makePaymentSubscriptionWeChat,
  makePaymentWeChat,
  updatePayment,
} from '@/services/payment';

const getters = {
  per_page: state => state.per_page,
  creditTrxData: state => state.creditTrxData,
  subscriptionTrxData: state => state.subscriptionTrxData,
  donationTrxData: state => state.donationTrxData,
  changeSubsTrxData: state => state.changeSubsTrxData,
  paymentError: state => state.paymentError,
  paymentPending: state => state.paymentPending,
  intervalCheckPending: state => state.intervalCheckPending,
};

const actions = {
  async requestPaymentMethods({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await getPaymentMethods({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);

      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },

  async requestClientKey({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await getClientKey({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = response.clientKey !== undefined ? response.clientKey : returnRes;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestMakePayment({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await makePayment({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestMakePaymentWeChat({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await makePaymentWeChat({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestConfirmPayment({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await confirmPayment({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },

  async requestPaymentMethodsSubscription({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await getPaymentMethodsSubscription({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);

      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },

  async requestMakePaymentSubscription({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await makePaymentSubscription({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestMakePaymentSubscriptionWeChat({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await makePaymentSubscriptionWeChat({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestMakePaymentSubscriptionPayMongo({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await makePaymentSubscriptionPayMongo({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestConfirmPaymentSubscription({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await confirmPaymentSubscription({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestConfirmPaymentSubscriptionPayMongo({ commit, rootGetters }, data) {
    let returnRes = null;
    try {
      const response = await confirmPaymentSubscriptionPayMongo({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-paymongo-confirm' }, { root: true });
    } finally { }
    return returnRes;
  },
  async requestCancelSubscription({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await cancelSubscription({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestMakePaymentDonation({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await makePaymentDonation({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestCancelDonation({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await cancelDonation({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      returnRes = response;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestChangeAmountSubscription({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      returnRes = await changeAmountSubscription({
        tokenType: rootGetters['AuthModule/tokenType'],
        accessToken: rootGetters['AuthModule/accessToken'],
      }, data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'change-amount-subs' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestUpdatePayment({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      returnRes = await updatePayment({
        tokenType: rootGetters['AuthModule/tokenType'],
        accessToken: rootGetters['AuthModule/accessToken'],
      }, data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'update-payment' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  setPaymentData({ commit, rootGetters }, data) {
    localStorage.setItem('_credTrxData', JSON.stringify(data));
    commit('SET_TRX_DATA', data);
  },
  removePaymentData({ commit, rootGetters }) {
    localStorage.removeItem('_credTrxData');
    commit('REMOVE_TRX_DATA');
  },
  setPaymentDataSubscription({ commit, rootGetters }, data) {
    localStorage.setItem('_subsTrxData', JSON.stringify(data));
    commit('SET_TRX_DATA_SUBSCRIPTION', data);
  },
  removePaymentDataSubscription({ commit, rootGetters }) {
    localStorage.removeItem('_subsTrxData');
    commit('REMOVE_TRX_SUBSCRIPTION');
  },
  setPaymentDataDonation({ commit, rootGetters }, data) {
    localStorage.setItem('_donaTrxData', JSON.stringify(data));
    commit('SET_TRX_DATA_DONATION', data);
  },
  removePaymentDataDonation({ commit, rootGetters }) {
    localStorage.removeItem('_donaTrxData');
    commit('REMOVE_TRX_DONATION');
  },
  setPaymentDataChangeSubs({ commit, rootGetters }, data) {
    localStorage.setItem('_changeSubsTrxData', JSON.stringify(data));
    commit('SET_TRX_DATA_CHANGE_SUBS', data);
  },
  removePaymentDataChangeSubs({ commit, rootGetters }) {
    localStorage.removeItem('_changeSubsTrxData');
    commit('REMOVE_TRX_CHANGE_SUBS');
  },
  setPaymentError({ commit, rootGetters }, data) {
    localStorage.setItem('_TrxErr', JSON.stringify(data));
    commit('SET_TRX_ERROR', data);
  },
  removePaymentError({ commit, rootGetters }) {
    localStorage.removeItem('_TrxErr');
    commit('REMOVE_TRX_ERROR');
  },
  setPaymentPending({ commit, rootGetters }, data) {
    localStorage.setItem('_TrxPend', JSON.stringify(data));
    commit('SET_TRX_PENDING', data);
  },
  removePaymentPending({ commit, rootGetters }) {
    localStorage.removeItem('_TrxPend');
    commit('REMOVE_TRX_PENDING');
  },
  setIntervalCheckPending({ commit, rootGetters }, data) {
    localStorage.setItem('_IntvCheckPend', JSON.stringify(data));
    commit('SET_INTV_CHECK_PENDING', data);
  },
  removeIntervalCheckPending({ commit, rootGetters }) {
    localStorage.removeItem('_IntvCheckPend');
    commit('REMOVE_INTV_CHECK_PENDING');
  },
};

const mutations = {
  SET_TRX_DATA(state, data) {
    state.creditTrxData = data;
  },
  REMOVE_TRX_DATA(state) {
    state.creditTrxData = '';
  },
  SET_TRX_DATA_SUBSCRIPTION(state, data) {
    state.subscriptionTrxData = data;
  },
  REMOVE_TRX_SUBSCRIPTION(state) {
    state.subscriptionTrxData = '';
  },
  SET_TRX_DATA_DONATION(state, data) {
    state.donationTrxData = data;
  },
  REMOVE_TRX_DONATION(state) {
    state.donationTrxData = '';
  },
  SET_TRX_DATA_CHANGE_SUBS(state, data) {
    state.changeSubsTrxData = data;
  },
  REMOVE_TRX_CHANGE_SUBS(state) {
    state.changeSubsTrxData = '';
  },
  SET_TRX_ERROR(state, data) {
    state.paymentError = data;
  },
  REMOVE_TRX_ERROR(state) {
    state.paymentError = '';
  },
  SET_TRX_PENDING(state, data) {
    state.paymentPending = data;
  },
  REMOVE_TRX_PENDING(state) {
    state.paymentPending = '';
  },
  SET_INTV_CHECK_PENDING(state, data) {
    state.intervalCheckPending = data;
  },
  REMOVE_INTV_CHECK_PENDING(state) {
    state.intervalCheckPending = '';
  },
};

export default {
  namespaced: true,
  state: {
    per_page: 50,
    creditTrxData: JSON.parse(localStorage.getItem('_credTrxData')) || '',
    subscriptionTrxData: JSON.parse(localStorage.getItem('_subsTrxData')) || '',
    donationTrxData: JSON.parse(localStorage.getItem('_donaTrxData')) || '',
    changeSubsTrxData: JSON.parse(localStorage.getItem('_changeSubsTrxData')) || '',
    paymentError: JSON.parse(localStorage.getItem('_TrxErr')) || '',
    paymentPending: JSON.parse(localStorage.getItem('_TrxPend')) || '',
    intervalCheckPending: JSON.parse(localStorage.getItem('_IntvCheckPend')) || '',
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Payment/index.js